import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    cards  : [],
    filters: [
      {
        text      : 'Текущие курсы',
        name      : 'current',
        image     : 'course-lesson',
        label_text: 'Идёт обучение',
        selected  : true,
        color     : '#e2173d',
        card_image: 'study-book',
      },
      {
        text      : 'Новые курсы',
        name      : 'newcourse',
        label_text: 'Новый',
        image     : 'course-go',
        selected  : false,
        color     : '#44b69e',
        card_image: 'new-book',
      },
      {
        text      : 'Завершенные курсы',
        name      : 'finished',
        label_text: 'Завершён',
        image     : 'course-complete',
        selected  : false,
        color     : '#9b9b9b',
        card_image: 'closed-book',
      },
    ],
    course_time         : 20,
    lessons_passed      : 0,
    lessons_total       : 0,
    points_earned_test  : 0,
    points_required_test: 1,
    points_total_test   : 2,
    courses_number      : {
      'current'  : 0,
      'newcourse': 0,
      'finished' : 0,
    },
  },
  mutations: {
    SELECT_FILTER(state, index) {
      state.filters.forEach((filter, i) => {
        filter.selected = (i === index);
      });
    },
    SET_CARDS(state, cards) {
      state.cards = cards;
    },
    COUNT_COURSES(state, value) {
      state.courses_number = value;
    },
  },
  getters: {
    cards               : ({cards}) => cards,
    amount_coutses      : ({cards}) => cards.length,
    courses_number      : ({courses_number}) => courses_number,
    course_time         : ({course_time}) => course_time,
    lessons_passed      : ({lessons_passed}) => lessons_passed,
    lessons_total       : ({lessons_total}) => lessons_total,
    points_earned_test  : ({points_earned_test}) => points_earned_test,
    points_required_test: ({points_required_test}) => points_required_test,
    points_total_test   : ({points_total_test}) => points_total_test,
    filters             : ({filters}) => filters,
    selected_filter     : ({filters}) => filters.find((filter) => filter.selected),
    filter_by_type      : ({filters}) => (type) => filters.find((filter) => filter.name === type),
    filtered_cards({cards}, {selected_filter}) {
      if (selected_filter && cards) {
        return cards.filter((card) => card.type == selected_filter.name);
      } else {
        return cards;
      }
    },
    get_card_by_id: ({cards}, {filter_by_type}) => (id) => {
      if (cards.length != 0) {
        const card = cards.find((card) => card.id == id);
        card.filter = filter_by_type(card.type);
        return card;
      }
    },
    cards_ids: ({cards}) => cards.map(({id}) => id),
  },
  actions: {
    async get_courses({getters, commit}) {
      const {selected_filter} = getters;
      let courses = [];
      try {
        if (selected_filter.name == 'newcourse') {
          courses = await api.course.get_new_courses();
        } else if (selected_filter.name == 'finished') {
          courses = await api.course.get_finished_courses();
        } else {
          courses = await api.course.get_current_courses();
        }

        commit('SET_CARDS', courses);
      } catch (err) {
        console.error(err);
        commit('SET_CARDS', []);
      }
    },
    async courses_count({commit}) {
      try {
        const courses = await api.course.courses_count();
        commit('COUNT_COURSES', courses.data);
      } catch (err) {
        console.error(err);
      }
    },
    async courses_count_business_plus({commit}) {
      try {
        const courses = await api.course.courses_count_business_plus();
        commit('COUNT_COURSES', courses.data);
      } catch (err) {
        console.error(err);
      }
    },
  },

};

